import Footer from '../../../layout/Footer/Footer';

const DefaultFooter = () => {
	return (
		<Footer>
			<div className='container-fluid'>
				<div className='row'>
					<div className='col'>
						<div className='col-lg-6 d-flex justify-content-center align-items-center'>
							{/* Logo grande e centrato */}
						</div>
					</div>
				</div>
				<div className='row mt-3'>
					<div className='col text-center'>
						<p className='mb-0'>
							Copyright ©️ 2025 . Clean Energy Consulting, BG207828028, Rayko Daskalov St. 68, Floor
							2, Office 8, 4000, Plovdiv, Bulgaria
						</p>
					</div>
				</div>
			</div>
		</Footer>
	);
};

export default DefaultFooter;
